import styled from 'styled-components';
import { COLOR, mobile } from '../../../styles/variables';
import { Position } from '../../../config/models';

export const QuoteLayout = styled.div<{ position?: Position }>`
    display: inline-block;
    line-height: 1.3;
    float: ${({ position }) => (position === Position.RIGHT ? 'right' : 'left')};
    text-align: ${({ position }) => (position === Position.RIGHT ? 'left' : 'right')};
    margin: ${({ position }) =>
        position === Position.RIGHT ? `0.5rem -3rem 1.5rem 3rem` : `0.5rem 3rem 1.5rem -3rem`};
    position: relative;
    max-width: 50%;

    :before {
        display: block;
        content: '“';
        font-size: 5rem;
        position: absolute;
        ${({ position }) => (position === Position.RIGHT ? 'right: -50px' : 'left: -50px')};
        top: -10px;
    }

    @media (orientation: portrait) {
        float: unset;
        display: block;
        margin: 3.2rem 2.4rem;
        text-align: center;
        max-width: unset;

        :before {
            top: -1rem;
            line-height: 1;
            ${({ position }) => (position === Position.RIGHT ? 'right:  -2.5rem' : 'left:  -2.5rem')};
            font-size: 3.5em;
        }
    }
`;

export const Text = styled.div`
    font-weight: 600;
    font-size: 1.25rem;
    margin-top: 1rem;
`;

export const Author = styled.div`
    margin-top: 0.5rem;
    color: ${COLOR.tertiary};
`;
